











import { defineComponent, computed } from '@vue/composition-api'
import PageHeaderNavigator from '@/components/PageHeaderNavigator.vue'

export default defineComponent({
  components: {
    PageHeaderNavigator
  },

  setup() {
    const navigationItems = computed(() => [
      {
        key: 'campaigns',
        title: 'Campaigns',
        route: {
          name: 'marketing.campaign-index'
        }
      },
      {
        key: 'appstore',
        title: 'iOS AppStore',
        route: {
          name: 'marketing.appstore-index'
        }
      },
      {
        key: 'emails',
        title: 'Email Templates',
        route: {
          name: 'marketing.email-index'
        }
      },
      {
        key: 'mailjet',
        title: 'Mailjet',
        route: {
          name: 'marketing.mailjet'
        }
      },
      {
        key: 'intercom',
        title: 'Intercom',
        route: {
          name: 'marketing.intercom'
        }
      }
    ])

    return {
      navigationItems
    }
  }
})
